import { type ComponentProps, type FC } from "react";
import { Salaries } from "@userFrontend/features/publication/components/Salaries";
import { LazyLoadImage } from "@root/shared/components/LazyLoadImage";
import { FooterButtons } from "./uiParts/FooterButtons";
import * as styles from "./styles.css";

type Props = {
  employmentAndSalaryType: ComponentProps<typeof Salaries>["employmentAndSalaryType"];
  imgSrc: string;
  shopLocation: string;
  shopOrBrandName: string;
  businessTypeAndOccupation: string;
  title: string;
  detailUrl: string;
  buttonProps: ComponentProps<typeof FooterButtons>;
  gaAction: string;
  gaLabel?: string;
};

export const DetailWorkCassette: FC<Props> = ({
  employmentAndSalaryType,
  imgSrc,
  shopLocation,
  shopOrBrandName,
  businessTypeAndOccupation,
  title,
  detailUrl,
  buttonProps,
  gaAction,
  gaLabel,
}) => {
  return (
    <div className={styles.wrapper}>
      {/* eslint-disable-next-line jsx-a11y/anchor-has-content */}
      <a
        href={detailUrl}
        className={styles.link}
        data-ga-action={gaAction}
        data-ga-label={gaLabel}
      />
      <div className={styles.shopInfoContainer}>
        <div className={styles.imageWrapper}>
          <LazyLoadImage src={imgSrc} alt="求人イメージ画像" width={75} height={43} />
        </div>
        <p className={styles.shopInfo}>
          {shopOrBrandName} / {businessTypeAndOccupation}
        </p>
      </div>
      <p className={styles.title}>{title}</p>
      <Salaries employmentAndSalaryType={employmentAndSalaryType} />
      {shopLocation && <p className={styles.shopLocation}>{shopLocation}</p>}
      <FooterButtons {...buttonProps} />
    </div>
  );
};
